export default "__VITE_ASSET__DtVgNdRx__"